import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { MASTER_FEATURE_FLAGS } from '@alpha-core/feature-flags/master-feature-flags.config';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { FEATURE_FLAGS_CONFIG_TOKEN } from '@neutrinos/ngx-feature-flags';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { routes } from './app.routes';
import { withCredInterceptor } from './interceptors/http.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        DialogService,
        MessageService,
        provideAnimations(),
        provideHttpClient(withFetch(), withInterceptors([withCredInterceptor])),
        provideRouter(routes),
        provideAnimationsAsync(),
        importProvidersFrom(MonacoEditorModule.forRoot()),
        importProvidersFrom(NgHttpLoaderModule.forRoot()),
        {
            provide: FEATURE_FLAGS_CONFIG_TOKEN,
            useValue: MASTER_FEATURE_FLAGS,
        },
    ],
};
